import OnDemandDevelopers from "../on-demand-developers";
import ProjectByEquity from "../project-by-equity";
import FullProjectDevelopment from "../full-project-development";
import WhatServices from "../what-services";
import Confirmation from "../confirmation";
import NavBar from "../nav-bar";
// import Intro from "../Intro";
import OurServices from "../our-services";
// import SeeOurWork from "../see-our-work";
// import ImpactAcrossIndustries from "../impact-across-industries";
// import WhatMakeUsDifferent from "../what-make-us-different";
// import WhatOurClientSays from "../what-our-client-says";
// import MeetOurTeam from "../meet-our-team";
// import AboutUs from "../about-us";
import Grid from "@mui/material/Grid/Grid";
import {
    CustomLabelLargeBoldRedHat,
    CustomLabelMediumBold,
    CustomLabelMediumRegular,
    CustomLabelMediumRegularRedHatInto, CustomLabelMediumSmallBold, 
} from "../common/CustomLabel";
import Box from "@mui/material/Box/Box";
import IPHONE151 from "../../assets/images/iPhone 15 Pro-1.png";
import ContactUs from "../contact-us";
import Footer from "../footer";
import React, {useRef, useState} from "react";
import {useMediaQuery} from "@mui/material";
import createTheme from "@mui/material/styles/createTheme";
import IntroDetails from "../intro-details";
// import WorkDetails from "../work-details";
// import PROJECT1 from "../../assets/images/project_1.png";
// import PROJECT2 from "../../assets/images/project2.png";
// import PROJECT3 from "../../assets/images/project3.png";
// import WorkCard from "../card-work";
// import OurTeam from "../our-team";
import TEAM_MEMBER from "../../assets/images/team-member.png";
import TEAM_MEMBER2 from "../../assets/images/team-member2.png";


import AboutUs1 from "../../assets/images/about-us-1.png";
import AboutUs2 from "../../assets/images/about-us-2.png";
import AboutUs3 from "../../assets/images/about-us-3.png";
import ListItem from "@mui/material/ListItem/ListItem";
import ListItemText from "@mui/material/ListItemText/ListItemText";
import List from "@mui/material/List/List";
import HAMZA from "../../assets/team/hamza.jpg";
import NAEEM from "../../assets/team/naeem.jpg";
import ETHAN from "../../assets/team/ethan.jpg";
import ABDULLAH from "../../assets/team/abdullah.jpg";
import JANNAT from "../../assets/team/jannat.jpg";
// import ASAD from "../../assets/team/asad.jpg";
// import ARSLAN from "../../assets/team/arslan.jpg";
// import IMRAAN from "../../assets/team/imran.jpg";
// import IJLAL from "../../assets/team/ijlal.jpg";
// import ZOHAIB from "../../assets/team/zohaib.jpg";
import SUMMIYA from "../../assets/team/summiya.jpg";
import { Helmet } from 'react-helmet';

const theme = createTheme({
    breakpoints: {
        values: {
            xs: 0,
            sm: 710,
            md: 950,
            lg: 1300,
            xl: 1350,
        },
    },
});


// Carousel settings for react-slick
// var settings_our_work = {
//     dots: false,
//     infinite: true,
//     speed: 500,
//     slidesToShow: 3,
//     slidesToScroll: 1,
//     initialSlide: 0,
//     adaptiveHeight: true,
//     responsive: [

//         {
//             breakpoint: 1300, // Large screens
//             settings: {
//                 slidesToShow: 2.5,
//             },
//         },

//         {
//             breakpoint: 1200, // Large screens
//             settings: {
//                 slidesToShow: 2.5,
//             },
//         },
//         {
//             breakpoint: 1024, // Large screens
//             settings: {
//                 slidesToShow: 2,
//             },
//         },
//         {
//             breakpoint: 700, // Large screens
//             settings: {
//                 slidesToShow: 1.5,
//             },
//         },
//         {
//             breakpoint: 480, // Mobile
//             settings: {
//                 slidesToShow: 1.2,
//             },
//         },
//     ],
// };


// Carousel settings for react-slick
// var settings = {
//     dots: false,
//     infinite: true,
//     speed: 500,
//     slidesToShow: 3,
//     slidesToScroll: 1,
//     initialSlide: 0,
//     adaptiveHeight: true,
//     responsive: [
//         {
//             breakpoint: 1024, // Large screens
//             settings: {
//                 slidesToShow: 2,
//             },
//         },
//         {
//             breakpoint: 480, // Mobile
//             settings: {
//                 slidesToShow: 1.2,
//             },
//         },
//     ],
// };


// Carousel settings for react-slick
// var profile_carousel_settings = {
//     dots: false,
//     infinite: true,
//     speed: 500,
//     slidesToShow: 4,
//     slidesToScroll: 1,
//     initialSlide: 0,
//     adaptiveHeight: true,
//     responsive: [
//         {
//             breakpoint: 1400, // Large screens
//             settings: {
//                 slidesToShow: 3.5,
//             },
//         },
//         {
//             breakpoint: 1200, // Large screens
//             settings: {
//                 slidesToShow: 2.5,
//             },
//         },
//         {
//             breakpoint: 1024, // Large screens
//             settings: {
//                 slidesToShow: 2.5,
//             },
//         },
//         {
//             breakpoint: 680, // Mobile
//             settings: {
//                 slidesToShow: 1.5,
//             },
//         },
//     ],
// };


const AboutUsDetails = ({}) => {

    const [isMenuClicked, setIsMenuClicked] = useState(false)

    // const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    const [showFullProject, setShowFullProject] = useState(false);
    const [showOnDemandDevelopers, setShowOnDemandDevelopers] = useState(false);
    const [showProjectByEquity, setShowProjectByEquity] = useState(false);
    const [showWhatServices, setShowWhatService] = useState(false);
    const [showConfirmation, setShowConfirmation] = useState(false);


    const serviceRef = useRef(null);
    const portfolioRef = useRef(null);
    const testimonalsRef = useRef(null);
    const partnersRef = useRef(null);
    const contactUsRef = useRef(null);

    // const BoardMembers = {
    //     title: "Board Members",
    //     description: "Our leadership team brings years of experience in technology, business strategy, and innovation, driving our company toward success.",
    //     developers: [
    //         {img: HAMZA, name: "Muhammad Hamza", role: "CEO & Co-Founder"},
    //         {img: NAEEM, name: "Naeeem Qureshi", role: "COO & Co-Founder"},
    //         {img: ETHAN, name: "Ethan Karian", role: "CBDO & Co-Founder"}
    //     ]
    // }


    // const ProjectManagers = {
    //     title: "Project Managers",
    //     description: "Ensuring smooth execution, timely delivery, and seamless communication, our project managers keep everything on track.",
    //     developers: [
    //         {img: ABDULLAH, name: "Abdullah", role: "CTO"},
    //         {img: JANNAT, name: "Jannat", role: "Business Development Manager"},
    //         {img: SUMMIYA, name: "Summiya", role: "Business Developer"}

    //     ]
    // }


    // const UiDesigners = {
    //     title: "UX/UI Designers",
    //     description: "Crafting beautiful and intuitive experiences, our designers turn ideas into engaging and user-friendly interfaces.",
    //     developers: [
    //         {img: TEAM_MEMBER, name: "John Doe", role: "Senior Product Designer"},
    //         {img: TEAM_MEMBER2, name: "Kenneth Allen", role: "UX/UI Designer"}
    //     ]
    // }


    // const FrontEndDevelopers = {
    //     title: "Front-End Developers",
    //     description: "Creating visually stunning and seamless user experiences, our front-end developers specialize in modern frameworks and responsive design.",
    //     developers: [
    //         {img: TEAM_MEMBER, name: "Autumn Phillips", role: "Senior Project Manager"},
    //         {img: TEAM_MEMBER2, name: "Stephanie Sharkey", role: "Junior Project Manager"},
    //         {img: TEAM_MEMBER, name: "Ricky Smith", role: "Junior Project Manager"}

    //     ]
    // }


    // const BackendDevelopers = {
    //     title: "Back-End Developers",
    //     description: "Building the foundation of high-performing applications, our back-end developers ensure security, efficiency, and scalability.",
    //     developers: [
    //         {img: TEAM_MEMBER, name: "Autumn Phillips", role: "Senior Project Manager"},
    //         {img: TEAM_MEMBER2, name: "Stephanie Sharkey", role: "Junior Project Manager"},
    //         {img: TEAM_MEMBER, name: "Ricky Smith", role: "Junior Project Manager"}

    //     ]
    // }


    // const MobileAppDevelopers = {
    //     title: "Mobile App Developers",
    //     description: "Delivering seamless mobile experiences, our mobile developers craft high-performance apps for iOS and Android.",
    //     developers: [
    //         {img: TEAM_MEMBER, name: "Autumn Phillips", role: "Senior Project Manager"},
    //         {img: TEAM_MEMBER2, name: "Stephanie Sharkey", role: "Junior Project Manager"},
    //         {img: TEAM_MEMBER, name: "Ricky Smith", role: "Junior Project Manager"}

    //     ]
    // }


    return (
        <Grid style={{width: "100vw", height: "100vh", overflowX: "hidden",}}>
            <Helmet>
                    <title> About Us - High-Quality Digital Solutions Company | OSTRYX</title>
                    <meta name="url" content="https://ostryx.com/about-us" />
                    <link rel="canonical" href="https://ostryx.com/about-us" />
                    <meta name="title" content=" About Us - High-Quality Digital Solutions Company | OSTRYX" />
                    <meta name="description" content="OSTRYX is a leading custom Quality Digital Solutions Company, delivering innovative, high-quality software solutions tailored to your business needs." />
                    <meta name="keywords" content="OSTRYX, digital solutions, software development, web development, mobile apps, enterprise technology, business solutions, IT services," />
                    <meta property="og:title" content="About Us - High-Quality Digital Solutions Company | OSTRYX" />
                    <meta property="og:description" content="OSTRYX is a leading custom Quality Digital Solutions Company, delivering innovative, high-quality software solutions tailored to your business needs." />
            </Helmet>

            {
                showOnDemandDevelopers && <OnDemandDevelopers setShowOnDemandDevelopers={setShowOnDemandDevelopers}
                                                              setShowConfirmation={setShowConfirmation}
                />
            }

            {
                showProjectByEquity && <ProjectByEquity setShowProjectByEquity={setShowProjectByEquity}
                                                        setShowConfirmation={setShowConfirmation}/>
            }


            {
                showFullProject && <FullProjectDevelopment setShowFullProject={setShowFullProject}
                                                           setShowConfirmation={setShowConfirmation}/>
            }


            {
                showWhatServices &&
                <WhatServices setShowWhatService={setShowWhatService} setShowFullProject={setShowFullProject}
                              setShowProjectByEquity={setShowProjectByEquity}
                              setShowOnDemandDevelopers={setShowOnDemandDevelopers}/>
            }


            {
                showConfirmation && <Confirmation setShowConfirmation={setShowConfirmation}/>
            }

            <NavBar isMenuClicked={isMenuClicked} serviceRef={serviceRef} portfolioRef={portfolioRef}
                    testimonalsRef={testimonalsRef} partnersRef={partnersRef} setIsMenuClicked={setIsMenuClicked}
                    contactUsRef={contactUsRef}
                    setShowWhatService={setShowWhatService}/>


            <IntroDetails title={"About Ostryx"}
                          hideSearch={true}
                          description={
                            <>
                            Hiring skilled developers has become a frustrating and unreliable process. Businesses face long hiring cycles, inconsistent talent, and the constant risk of scams on freelancing platforms. Too much time is wasted reviewing profiles, negotiating terms, and dealing with missed deadlines—with no guarantee of quality work.
                            {/* <br/> */}
                            <b>OSTRYX</b> was founded in  <b>2018</b> to solve this problem. <b>Our mission</b> is to connect businesses with <b>trusted, highly skilled developers</b> who deliver <b>real, high-quality digital solutions.</b>
                            {/* <br/> */}
                            With a strong focus on the American market, we offer on-demand developers, full project development, and equity-based partnerships. In <b>2024</b>, Ethan Karian—once a client who faced scams himself - joined as a partner to help expand <b>OSTRYX</b> into North America.
                            {/* <br/> */}
                            While freelancing platforms come with hiring challenges and uncertain talent, <b>OSTRYX</b> ensures a smooth, professional, and reliable digital development experience.
                            </>}
                            tag={''}
            />

            <Grid container justifyContent={"center"}>
                <Grid item container xs={10} md={11} lg={10} justifyContent={"space-between"} alignItems={"center"}
                      sx={{marginTop: "80px"}}>

                    <Grid item xs={12} md={5.5}>
                        <Grid item xs={12} sx={{textAlign: {xs: "center", md: "left"}}}>
                            <CustomLabelMediumSmallBold text={"Our Mission"} color={"#5E17EB"}/>
                        </Grid>


                        <Grid item xs={12} sx={{display:{xs:"flex",md:"none"},marginTop:{xs:"5px",md:"none"}}} >
                            <Box component={"img"} src={AboutUs1} alt={"Our Mission"} sx={{width: "100%",marginTop:{xs:"20px",md:"0px"}, borderRadius: "20px"}} />
                        </Grid>
                        <Grid item xs={12} sx={{marginTop: {xs:"20px",md:"5px"}}}>
                            <CustomLabelMediumRegularRedHatInto color={"#333333"}
                                                                style={{textAlign: "justify", lineHeight: 1.4}}
                                                                text={<>At <b>OSTRYX</b>, we are committed to transforming 
                                                                    how businesses build and scale digital solutions. 
                                                                    By providing top-tier developers, full-cycle project 
                                                                    development, and risk-free equity partnerships, we 
                                                                    resolve hiring uncertainties. Our goal is to foster 
                                                                    long-term collaborations that drive success, ensuring 
                                                                    every project is executed with expertise, efficiency, 
                                                                    and transparency.</>}
                            ></CustomLabelMediumRegularRedHatInto>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} md={5.5} sx={{display:{xs:"none",md:"flex"}}}>
                        <Box component={"img"} src={AboutUs1} alt={"Our Mission"} sx={{width: "100%",marginTop:{xs:"20px",md:"0px"}, borderRadius: "20px"}}/>
                    </Grid>

                </Grid>

                <Grid item container xs={10} md={11} lg={10} justifyContent={"space-between"} alignItems={"center"}
                      sx={{marginTop: "80px"}}>

                    <Grid item xs={12} md={5.5} sx={{display:{xs:"none",md:"flex"}}}>
                        <Box component={"img"} src={AboutUs2} alt={"Our Core Values"} sx={{width: "100%", borderRadius: "20px"}}/>
                    </Grid>


                    <Grid item xs={12} md={5.5} sx={{width: "100%",marginTop:{xs:"30px",md:"0px"}}}>
                        <Grid item xs={12} sx={{textAlign: {xs: "center", md: "left"}}}>
                            <CustomLabelMediumSmallBold text={"Our Core Values"} color={"#5E17EB"}/>
                        </Grid>
                        <Grid item xs={12} sx={{display:{xs:"flex",md:"none"},marginTop:{xs:"5px",md:"none"}}} >
                            <Box component={"img"} src={AboutUs2} alt={"Our Core Values"} sx={{width: "100%",marginTop:{xs:"20px",md:"0px"}, borderRadius: "20px"}}/>
                        </Grid>


                        <Grid item xs={12} sx={{marginTop: {xs:"20px",md:"5px"}}}>


                            <List sx={{listStyleType: 'disc', pl: 1, marginLeft: "20px"}}>
                                <ListItem sx={{display: 'list-item', p: {xs:1,md:0}}}>
                                    <ListItemText primary={
                                        <CustomLabelMediumRegularRedHatInto
                                            style={{textAlign: "justify"}}
                                            normal={true} color={"#333333"}
                                            text={<> 
                                                <b>Innovation:</b> 
                                                &nbsp;Our team brings fresh, innovative ideas and continuously 
                                                finds new ways to solve challenges, always looking for better, 
                                                smarter solutions.
                                                </>}
                                        />

                                    }/>
                                </ListItem>
                                <ListItem sx={{display: 'list-item', p: {xs:1,md:0}}}>
                                    <ListItemText primary={
                                        <CustomLabelMediumRegularRedHatInto
                                            style={{textAlign: "justify"}}
                                            normal={true} color={"#333333"}
                                            text={<>
                                                <b>Excellence:</b> 
                                                &nbsp;At <b>OSTRYX</b>, We are committed to delivering outstanding 
                                                results, going beyond expectations to ensure the highest quality 
                                                in everything we do.
                                                </>}
                                        />

                                    }/>
                                </ListItem>
                                <ListItem sx={{display: 'list-item', p: {xs:1,md:0}}}>
                                    <ListItemText primary={
                                        <CustomLabelMediumRegularRedHatInto
                                            style={{textAlign: "justify"}}
                                            normal={true} color={"#333333"}
                                            text={<>
                                                <b>Collaboration:</b> 
                                                &nbsp;At <b>OSTRYX</b>, We believe in the power of teamwork, 
                                                working closely with our clients and partners to turn ideas into 
                                                successful, long-term solutions.
                                                </>}
                                        />

                                    }/>
                                </ListItem>

                                <ListItem sx={{display: 'list-item', p: {xs:1,md:0}}}>
                                    <ListItemText primary={
                                        <CustomLabelMediumRegularRedHatInto
                                            style={{textAlign: "justify"}}
                                            normal={true} color={"#333333"}
                                            text={<>
                                                <b>Integrity:</b> 
                                                &nbsp;We build lasting trust through honesty, transparency, and 
                                                strong ethical practices, ensuring fairness in every interaction.
                                                </>}
                                        />

                                    }/>
                                </ListItem>


                            </List>

                        </Grid>
                    </Grid>

                </Grid>


                <Grid item container xs={10} md={10} justifyContent={"center"} alignItems={"center"} sx={{marginTop: "80px"}}>

                    <CustomLabelLargeBoldRedHat fontWeight={"bold"} style={{textAlign: "center"}} color={"#5E17EB"}
                                                     lineHeight={1.2}
                                                     text={"3x Business Success with Smart, Scalable, and Impactful Digital Solutions"}></CustomLabelLargeBoldRedHat>


                </Grid>


                <Grid item container xs={10} md={11} lg={10} justifyContent={"center"} alignItems={"center"} sx={{marginTop: "80px"}}>

                    <CustomLabelMediumRegularRedHatInto color={"#333333"} style={{textAlign: "justify", lineHeight: 1.4}}
                                                        text={<>
                                                        We are a team of dedicated professionals committed to 
                                                        delivering high-quality digital solutions for businesses 
                                                        of all sizes. Based in the <b>USA</b>, we specialize in <b>On-Demand 
                                                        Development, Full-Scale Project Execution,</b> and <b>Equity-based 
                                                        partnerships</b> to help businesses grow and scale effectively.
                                                        </>}
                                                        >
                                                        </CustomLabelMediumRegularRedHatInto>


                </Grid>


                <Grid item container xs={10} md={11} lg={10} justifyContent={"center"} alignItems={"center"} sx={{marginTop: "40px"}}>

                    <CustomLabelMediumRegularRedHatInto color={"#333333"} style={{textAlign: "justify", lineHeight: 1.4}}
                                                        text={<>
                                                        With expertise in <b>Front-end, Back-end,</b> and <b>Mobile App development</b>, 
                                                        using <b>AI-driven automation, cloud-native architecture, and high-speed 
                                                        frameworks</b> to create <b>scalable, secure, and user-friendly</b> solutions 
                                                        that meet the highest industry standards. We prioritize <b>transparency, 
                                                        collaboration,</b> and <b>long-term success</b>, ensuring every project is built 
                                                        with precision and reliability.
                                                        </>}
                    ></CustomLabelMediumRegularRedHatInto>


                </Grid>


                <Grid item container xs={10} md={11} lg={10} justifyContent={"center"} alignItems={"center"} sx={{marginTop: "40px"}}>

                    <CustomLabelMediumRegularRedHatInto color={"#333333"} style={{textAlign: "justify", lineHeight: 1.4}}
                                                        text={<>
                                                        Whether you need to <b>Hire Skilled Developers</b>, 
                                                        build a product from the ground up, or explore an &nbsp;
                                                        <b>Equity-based partnership</b>, we are here to bring 
                                                        your vision to success with expertise and innovation.
                                                        </>}
                    ></CustomLabelMediumRegularRedHatInto>


                </Grid>




                <Grid item container xs={10} md={11} lg={10} justifyContent={"space-between"} alignItems={"center"}
                      sx={{marginTop: "80px"}}>



                    <Grid item xs={12} md={5.5}>
                        <Grid item xs={12} sx={{textAlign: {xs: "center", md: "left"}}}>
                            <CustomLabelMediumSmallBold text={"Why OSTRYX? – Precision, Performance, Progress"} color={"#5E17EB"}/>
                        </Grid>


                        <Grid item xs={12} sx={{display:{xs:"flex",md:"none"},marginTop:{xs:"5px",md:"none"}}} >
                            <Box component={"img"} src={AboutUs3} alt={"Why OSTRYX?"} sx={{width: "100%",marginTop:{xs:"20px",md:"0px"}}}/>
                        </Grid>

                        <Grid item xs={12} sx={{marginTop: {xs:"20px",md:"5px"}}}>


                            <List sx={{listStyleType: 'disc', pl: 1, marginLeft: "20px"}}>
                                <ListItem sx={{display: 'list-item', p: {xs:1,md:0}}}>
                                    <ListItemText primary={
                                        <CustomLabelMediumRegularRedHatInto
                                            style={{textAlign: "justify"}}
                                            normal={true} color={"#333333"}
                                            text={<>
                                                <b>Immediate Talent Access</b> – Skip the long hiring process and onboard skilled professionals immediately.
                                                </>}
                                        />

                                    }/>
                                </ListItem>
                                <ListItem sx={{display: 'list-item', p: {xs:1,md:0}}}>
                                    <ListItemText primary={
                                        <CustomLabelMediumRegularRedHatInto
                                            style={{textAlign: "justify"}}
                                            normal={true} color={"#333333"}
                                            text={<>
                                                <b>Skilled & Adaptable Expertise </b> – Our team quickly adapts to project changes, tackling challenges with precision and efficiency.
                                                </>}
                                        />

                                    }/>
                                </ListItem>
                                <ListItem sx={{display: 'list-item', p: {xs:1,md:0}}}>
                                    <ListItemText primary={
                                        <CustomLabelMediumRegularRedHatInto
                                            style={{textAlign: "justify"}}
                                            normal={true} color={"#333333"}
                                            text={<>
                                                <b>Continuous Support</b> – From development to <b>post-launch,</b> we provide long-term technical assistance.
                                                </>}
                                        />

                                    }/>
                                </ListItem>

                                {/* <ListItem sx={{display: 'list-item', p: {xs:1,md:0}}}>
                                    <ListItemText primary={
                                        <CustomLabelMediumRegularRedHatInto
                                            style={{textAlign: "justify"}}
                                            normal={true} color={"#333333"}
                                            text={<>
                                                <b>Scam-Free Hiring</b> – No fake resumes, no hidden fees—just <b>verified, top-tier developers</b> ready to deliver.
                                                </>}
                                        />

                                    }/>
                                </ListItem> */}


                                <ListItem sx={{display: 'list-item', p: {xs:1,md:0}}}>
                                    <ListItemText primary={
                                        <CustomLabelMediumRegularRedHatInto
                                            style={{textAlign: "justify"}}
                                            normal={true} color={"#333333"}
                                            text={<>
                                                <b>Growth-Driven Partnerships</b> – We go beyond traditional services by <b>investing in high-potential projects,</b> sharing both risk and reward to fuel long-term success.
                                                </>}
                                        />

                                    }/>
                                </ListItem>

                                <ListItem sx={{display: 'list-item', p: {xs:1,md:0}}}>
                                    <ListItemText primary={
                                        <CustomLabelMediumRegularRedHatInto
                                            style={{textAlign: "justify"}}
                                            normal={true} color={"#333333"}
                                            text={<>
                                                <b>Project by Equity</b> – We invest our expertise in high-potential ideas, eliminating upfront costs and sharing success.
                                                </>}
                                        />

                                    }/>
                                </ListItem>

                                <ListItem sx={{display: 'list-item', p: {xs:1,md:0}}}>
                                    <ListItemText primary={
                                        <CustomLabelMediumRegularRedHatInto
                                            style={{textAlign: "justify"}}
                                            normal={true} color={"#333333"}
                                            text={<>
                                                <b>Developer Replacement</b> – Not satisfied? Easily swap developers without delays or extra costs.
                                                </>}
                                        />

                                    }/>
                                </ListItem>

                                <ListItem sx={{display: 'list-item', p: {xs:1,md:0}}}>
                                    <ListItemText primary={
                                        <CustomLabelMediumRegularRedHatInto
                                            style={{textAlign: "justify"}}
                                            normal={true} color={"#333333"}
                                            text={<>
                                                <b>Collaboration</b> – No hidden fees, no surprises—just <b>clear communication, fair pricing, and a commitment to delivering results.</b>
                                                </>}
                                        />

                                    }/>
                                </ListItem>


                            </List>

                        </Grid>
                    </Grid>



                    <Grid item xs={5.5} sx={{display:{xs:"none",md:"flex"}}}>
                        <Box component={"img"} src={AboutUs3} alt={"Why OSTRYX?"} sx={{width: "100%"}}/>
                    </Grid>

                </Grid>

            </Grid>


            <OurServices serviceRef={serviceRef} setShowOnDemandDevelopers={setShowOnDemandDevelopers}
                         setShowWhatService={setShowWhatService}
                         setShowFullProject={setShowFullProject}
                         setShowProjectByEquity={setShowProjectByEquity}/>


            <Grid container sx={{paddingBottom: {xs: "30px", md: "50px"}, px :{ xs: 1, md: 5}}} justifyContent={"center"}>

                <Grid item container justifyContent={"center"} sx={{marginTop: {xs: "20px", md: "50px"}}}>
                    <CustomLabelMediumBold text={"Discuss Your Project with #1 Software Development Company USA "} color={"#5E17EB"}/>
                </Grid>

                <Grid item container xs={10} style={{marginTop: "5px"}} justifyContent={"center"}>
                    <CustomLabelMediumRegular normal={false}
                                              text={"Got an Idea? Let’s Build It Together — Contact Us for Expert Development Solutions."}
                    />
                </Grid>


                <Grid item container xs={12} justifyContent={"space-between"}
                      sx={{padding: {xs: "0px 10px", md: "0px 40px"}, marginTop: {xs: "20px", lg: "60px"}}}>


                    <Grid item xs={12} lg={4.8}
                          sx={{maxHeight: "100%", width: "100%", padding: "0px", position: "relative"}}>
                        <Box component={"img"} src={IPHONE151} alt={"OSTRYX"}
                             sx={{height: {lg: "100%"}, width: {xs: "100%", lg: "100%", xlg: "auto"}}}/>
                    </Grid>

                    <ContactUs setShowConfirmation={setShowConfirmation}/>


                </Grid>

                <div ref={contactUsRef} tabIndex={0}></div>

            </Grid>


            <Footer/>

        </Grid>
    )
}

export default AboutUsDetails;
